import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}: ButtonProps) => {
  // Enhanced base classes with ripple and bounce effects
  const baseClasses = 'font-mono uppercase tracking-widest font-semibold border-4 transition-all duration-200 focus:outline-none focus:ring-4 disabled:opacity-50 disabled:cursor-not-allowed active:translate-x-1 active:translate-y-1 btn-ripple relative overflow-hidden gpu-accelerated';

  const variantClasses = {
    primary: 'bg-amaranth_purple-500 border-amaranth_purple-700 text-white hover:bg-amaranth_purple-600 hover:-translate-x-1 hover:-translate-y-1 shadow-[8px_8px_0px_0px_rgba(2,5,18,1)] hover:shadow-[12px_12px_0px_0px_rgba(2,5,18,1)] focus:ring-amaranth_purple-300 active:shadow-[4px_4px_0px_0px_rgba(2,5,18,1)]',
    secondary: 'bg-indigo_dye-500 border-indigo_dye-700 text-white hover:bg-indigo_dye-600 hover:-translate-x-1 hover:-translate-y-1 shadow-[8px_8px_0px_0px_rgba(2,5,18,1)] hover:shadow-[12px_12px_0px_0px_rgba(2,5,18,1)] focus:ring-indigo_dye-300 active:shadow-[4px_4px_0px_0px_rgba(2,5,18,1)]',
    outline: 'bg-white border-rich_black-500 text-rich_black-500 hover:bg-rich_black-500 hover:text-white hover:-translate-x-1 hover:-translate-y-1 shadow-[8px_8px_0px_0px_rgba(2,5,18,1)] hover:shadow-[12px_12px_0px_0px_rgba(2,5,18,1)] focus:ring-gray-300 active:shadow-[4px_4px_0px_0px_rgba(2,5,18,1)]',
    ghost: 'bg-transparent border-transparent text-gray-700 hover:bg-gray-100 hover:border-gray-300 focus:ring-gray-300',
  };

  const sizeClasses = {
    xs: 'px-3 py-1 text-xs min-h-[32px]',
    sm: 'px-4 py-2 text-sm min-h-[38px]',
    md: 'px-6 py-3 text-sm min-h-[44px]',
    lg: 'px-8 py-4 text-base min-h-[52px]',
    xl: 'px-10 py-5 text-lg min-h-[60px]',
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}; 